module.exports = __webpack_public_path__ + "img/booking_created.eb628786.svg";